// User slice
import { StateCreator, StoreApi } from "zustand";
import { User } from "@prisma/client";
import { UserExtended } from "@/types";
import { AppStoreState } from "../appStore";
type SetState = StoreApi<AppStoreState>["setState"];
type GetState = StoreApi<AppStoreState>["getState"];

const createUserSlice: StateCreator<
  AppStoreState,
  [],
  [],
  Pick<AppStoreState, "user" | "setUser" | "showAllData" | "setLoading">
> = (set: SetState, get: GetState, api: StoreApi<AppStoreState>) => ({
  user: null,
  setUser: (
    userOrUpdater:
      | UserExtended
      | null
      | ((prev: UserExtended | null) => UserExtended | null)
  ) => {
    if (typeof userOrUpdater === "function") {
      set((state: AppStoreState) => {
        const newUser = (
          userOrUpdater as (prev: UserExtended | null) => UserExtended | null
        )(state.user);
        return {
          user: newUser,
          /*companies: Array.isArray(newUser?.companies) ? newUser.companies : [],
          selectedCompany:
            newUser?.selectedCompany ??
            (Array.isArray(newUser?.companies) && newUser.companies.length > 0
              ? newUser.companies[0]
              : null),*/
        };
      });
    } else {
      set({
        user: userOrUpdater,
        /*
        companies: Array.isArray(userOrUpdater?.companies)
          ? userOrUpdater.companies
          : [],
        selectedCompany:
          userOrUpdater?.selectedCompany ??
          (Array.isArray(userOrUpdater?.companies) &&
          userOrUpdater.companies.length > 0
            ? userOrUpdater.companies[0]
            : null),*/
      });
    }
  },
  setLoading: (page: string, isLoading: boolean) =>
    set((state: AppStoreState) => ({
      loading: {
        ...(state.loading || {}),
        [page]: isLoading,
      },
    })),
  showAllData: async () => {
    await fetch("/api/user/setSelectedDate", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ year: "All", quarter: null, month: null }),
    });
    const userRes = await fetch("/api/user");
    const user = await userRes.json();
    set({ user });
  },
});

export default createUserSlice;
